import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { txt } from 'libs/i18n';
import { AppIcon } from 'components/CustomIcons';
import { useAppContext } from 'App/app-context';
import styles from './style.module.less';
const getAppDescription = (app, locale) => {
    var _a;
    const description = app.descriptions.find((desc) => desc.locale === locale.code);
    return (_a = description === null || description === void 0 ? void 0 : description.text) !== null && _a !== void 0 ? _a : null;
};
const AppCard = ({ app }) => {
    var _a;
    const { uiLocale } = useAppContext();
    const description = (_a = getAppDescription(app, uiLocale)) !== null && _a !== void 0 ? _a : `${txt('application')} ${app.displayName}`;
    return (_jsxs("div", { className: styles.appCard, children: [_jsx(AppIcon, { className: styles.icon }), _jsxs("div", { children: [_jsx("a", { className: styles.cardName, href: app.url, target: "_blank", rel: "noreferrer", children: app.displayName }), _jsx("div", { children: description })] })] }));
};
export default AppCard;
